export enum AgencyPermissionEnums {
  PRIMARY_IMAGE_SELECTION = 'Primary Image Selection',
  IMAGES = 'Images',
  VIDEOS = 'Videos',
  AUDIO_FILES = 'Audio Files',
  DOCUMENTS = 'Documents',
  RESUME_CATEGORIES = 'Resume Categories',
  COMPOSITE_CARD = 'Composite Card',
}
